<template>
    <div class="mt-5 border-top conditionProperties">
        <div class="d-flex justify-content-between">
            <div><strong>Conditions</strong></div>
            <div>
                <button class="btn btn-sm btn-secondary" @click="onAddConditionClick">add condition</button>
            </div>
        </div>

        <div v-for="rowCondition in layout.selectedRow.conditions" class="mt-2">
            <div class="mb-2 d-flex">
                <div>
                    Type: <strong>{{rowCondition.type}}</strong>
                </div>
                <div class="ms-1">
                    <i class="fas fa-times-circle pointer" @click="onRemoveConditionClick(rowCondition)"></i>
                </div>
            </div>

            <div class="d-flex">
                <div>
                    <select class="form-control editor-form editor-select" v-model="rowCondition.field_id">
                        <option v-for="field in table.fields" :value="field.index">{{field.name}}</option>
                    </select>
                </div>

                <div>
                    <select class="form-control editor-form editor-select" v-model="rowCondition.predicate">
                        <option>exists</option>
                        <option>does not exist</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LayoutFactory from "../../utils/LayoutFactory";

    export default {
        name: 'ConditionProperties',
        props: ['layout', 'table', 'view'],
        data() {
            return {
                model: webase.model,
                factory: new LayoutFactory()
            }
        },
        mounted() {
        },
        methods: {
            onAddConditionClick() {
                let condition = this.factory.createCondition()
                this.layout.selectedRow.conditions.push(condition)
            },

            onRemoveConditionClick(condition) {
                webase.utils.array.remove(this.layout.selectedRow.conditions, condition)
            }
        }
    }
</script>

